export const catalogo_efectos = {
    "Ritmo Cardiaco Elevado": false,
    "Sentimientos de Ansiedad": true,
    "Debilidad o Mareos ligeros": false,
    "Sedacion o Somnolencia": false,
    "Nauseas": false,
    "Vision Borrosa": false,
    "Aumento de la Presión Arterial": false,
    "Mareos": false,
    "Dolor de cabeza": false
}


export const desrealizacion = {
    "1. ¿Parece que las cosas se mueven en cámara lenta ?": [
        "No en absoluto",
        "Leve, las cosas parecen un poco más lentas, pero no muy notable.",
        "Moderado, las cosas se mueven aproximadamente el doble que normalmente.",
        "Grave, las cosas se mueven tan lentamente que apenas se mueven.",
        "Extremo, las cosas se mueven tan lentamente, que tengo la percepción de que todo se  detiene, como si el tiempo se detuviera."
    ],
    "2. ¿Te parecen irreales las cosas, como si estuvieras en un sueño?": [
        "No en absoluto.",
        "Leve, las cosas se ven un poco irreales, pero soy muy consciente de donde estoy.",
        "Moderado, las cosas parecen un sueño, aunque sé que estoy despierto.",
        "Grave, las cosas se parecen mucho a un sueño, aunque sé que estoy aquí, tengo el sentimiento de que pudiera estar dormido.",
        "Extremo, siento que nada es real, como si tuviera que pellizcarme para despertar, o preguntarle a alguien si esto es un sueño."
    ]
}

export const despersonalizacion = {
    "3. ¿Te sientes desconectado de tu propio cuerpo?": [
        "No, en absoluto",
        "Leve, Me siento un poco desconectado de mi mismo, pero básicamente estoy completamente aquí.",
        "Moderado, Me siento algo desprendido de mi propio cuerpo, pero básicamente todo unido.",
        "Grave, me siento desprendido de mi propio cuerpo, pero no muy alejado de mi cuerpo, y siento como si estuviera yo ahí.",
        "Extremo, Me siento como si estuviera completamente fuera de mi cuerpo, como si estuviera viendo mi propio cuerpo desde muy lejos, como si estuviera otra persona ahí."
    ],
    "4. Sientes que ha cambiado el sentido de tu propio cuerpo?: por ejemplo, tu cuerpo se siente inusualmente largo o inusualmente pequeño?": [
        "No, en absoluto",
        "Leve, Tengo un vago sentimiento de que algo en mi cuerpo ha cambiado, pero no puedo decir exactamente que es.",
        "Moderado, Siento como que mi cuerpo ha aumentado o disminuido ligeramente de tamaño, o se siente como si no fuera mi cuerpo.",
        "Grave, Siento como si mi cuerpo ha aumentado el doble de si tamaño normal, o disminuido el doble de su tamaño normal.",
        "Extremo, siento como si mi cuerpo se hubiera hinchado al menos diez veces de su tamaño normal o como si fuera diez veces más pequeño, o como si mis brazos se hubieran convertido como palillos de dientes."
    ]
}

export const amnesia = {
    "5. Te has distraído, o has perdido el rastro de alguna manera de lo que esta pasando durante esta experiencia?": [
        "No en absoluto",
        "Leve, He tenido algunos episodios de haber perdido la noción sobre lo que está pasando, pero he seguido todo la mayor parte del tiempo.",
        "Moderado, He perdido al menos un minuto de tiempo, o perdido completamente la noción de lo que está pasando ahora.",
        "Grave, He perdido varios segmentos de tiempo de un minuto o más.",
        "Extremo, he perdido largos segmentos de tiempo de al menos 15 minutos o más."
    ],
    "6. Tiene lagunas (vacios) en su memoria?": [
        "No en lo absoluto",
        "Leve, Hay algunas cosas recientes que no puedo recordar.",
        "Moderado, Han habido algunas lagunas (vacios)  en mi memoria que duraron unos minutos",
        "Grave, Han habido largas lagunas (vacios) en mi memoria que duraron más de algunos minutos.",
        "Extremo, No puedo reconstruir lo que está pasando de un momento al siguiente, debido a largas lagunas (vacios)  en mi memoria."
    ]
}